import React from "react";
import { Skeleton as MUISkeleton } from "@mui/material";
import styled from "styled-components";

const StyledMUISkeleton = styled(MUISkeleton)``;

/**
 * Renders a skeleton component with customizable variant, width, and height.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} [props.variant="rectangular"] - The variant of the skeleton component.
 * @param {number} [props.width=210] - The width of the skeleton component.
 * @param {number} [props.height=60] - The height of the skeleton component.
 * @returns {JSX.Element} The rendered skeleton component.
 */
export const Skeleton = ({
  variant = "rectangular",
  width = 210,
  height = 60,
}) => {
  return <StyledMUISkeleton variant={variant} width={width} height={height} />;
};
